/** Every client route of the SPA. Links and the router both use these, never string literals. */
export const PATHS = {
  home: '/',
  login: '/login',
  welcome: '/welcome/:token',
  studio: '/studio',
  library: '/studio/library',
  asset: '/studio/library/:assetId',
  hosts: '/studio/hosts',
  invite: '/s/:code',
} as const;

const fill = (pattern: string, params: Readonly<Record<string, string>>): string =>
  pattern.replace(/:([A-Za-z]+)/g, (_, name: string) => encodeURIComponent(params[name] ?? ''));

export const pathTo = {
  asset: (assetId: string) => fill(PATHS.asset, { assetId }),
  invite: (code: string) => fill(PATHS.invite, { code }),
  login: (next?: string) => (next ? `${PATHS.login}?${new URLSearchParams({ next })}` : PATHS.login),
};

/** Only same-app paths are accepted as a post-login destination (no open redirects). */
export const safeNextPath = (next: string | null): string =>
  next?.startsWith('/') && !next.startsWith('//') ? next : PATHS.studio;

/** The SPA path of an absolute invite link from the API (same origin in every deployment). */
export const localPathOf = (absoluteUrl: string): string => {
  try {
    const url = new URL(absoluteUrl, window.location.origin);
    return `${url.pathname}${url.search}`;
  } catch {
    return absoluteUrl;
  }
};
